import { useFormat } from '@ideavivat/vivat-2';

export interface Stats { amount: number; [key: string]: any }
interface Timeframe {
  from: string;
  to: string;
}

export const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
export const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);

export const NOW = useFormat.date(new Date()).computerShortDate();
export const NOW_YEAR = new Date().getFullYear();
export const NOW_START_YEAR = `${NOW_YEAR}-01-01`;
export const NOW_MONTH = new Date().getMonth() + 1;
export const NOW_START_MONTH = `${NOW_YEAR}-${String(NOW_MONTH).padStart(2, '0')}-01`;
export const NOW_END_MONTH = useFormat.date(NOW_START_MONTH).computerShortDateEndOfMonth();
export function monthDays(start: string, end: string) {
  const length = useFormat.date(end).dayjs.diff(useFormat.date(start).dayjs, 'day');
  return Array.from({ length: length + 1 }, (x, i) => i + 1);
}
export function computerTime(date = NOW) {
  return useFormat.date(date).dayjs.format('HH:mm:ss');
}

export function shortNumberFormatter(num: number, digits = 0) {
  const lookup: { value: number; symbol: string }[] = [
    { value: -1e18, symbol: 'E' },
    { value: -1e15, symbol: 'P' },
    { value: -1e12, symbol: 'T' },
    { value: -1e9, symbol: 'G' },
    { value: -1e6, symbol: 'M' },
    { value: -1e3, symbol: 'k' },
    { value: -1, symbol: '' },
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find((itm) => num >= itm.value) as { value: number; symbol: string };
  const itemMinus = lookup
    .slice()
    .find((itm) => num < itm.value) as { value: number; symbol: string };
  if (num > 0 && num !== undefined && num !== null) {
    return ((num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol);
  }
  if (num < 0) {
    return `- ${(num / itemMinus.value).toFixed(digits).replace(rx, '$1') + itemMinus.symbol}`;
  }
  return '0';
}

export const toCommaFormat = (string: string | number, min = 0, max = 2) => parseFloat(string as string || '0').toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });
export function sortByAmount(record: Stats, nextRecord: Stats) {
  return nextRecord.amount - record.amount;
}

export function timeframeSubtract(timeframe: Timeframe, year = 1) {
  const from = useFormat.date(timeframe.from).dayjs.subtract(year, 'year').format('YYYY-MM-DD');
  const to = useFormat.date(timeframe.to).dayjs.subtract(year, 'year').format('YYYY-MM-DD');
  return { from, to };
}

export function timeframeMonthToMonth(timeframe: Timeframe) {
  const to = useFormat.date(timeframe.to).dayjs.add(1, 'day').format('YYYY-MM-DD');
  return { from: timeframe.from, to };
}

export default function utils() {
  return {};
}
